import { render, staticRenderFns } from "./FeedbackEditorApplicant.vue?vue&type=template&id=1c052ba6&"
import script from "./FeedbackEditorApplicant.vue?vue&type=script&lang=js&"
export * from "./FeedbackEditorApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports